import {ReactElement, useState} from "react";
import "../res/css/styles.css";

export function Keyboard(props: { onKey: (key: string) => void }): ReactElement {
  const [shifted, setShifted] = useState(true);

  const handleKey = (key: string) => {
    if (key === "BACKSPACE") {
      props.onKey("BACKSPACE");
    } else if (key === "SPACE") {
      props.onKey(" ");
    } else if (key === "SHIFT") {
      setShifted(!shifted);
    } else {
      props.onKey(shifted ? key.toUpperCase() : key.toLowerCase());
      setShifted(false);
    }
  };

  const row1 = ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"];
  const row2 = ["A", "S", "D", "F", "G", "H", "J", "K", "L"];
  const row3 = ["Z", "X", "C", "V", "B", "N", "M"];

  const displayKey = (k: string) => shifted ? k.toUpperCase() : k.toLowerCase();

  return <div className="keyboard">
    <div className="kb-row">
      {row1.map(k => <button key={k} className="key" onClick={() => handleKey(k)}>{displayKey(k)}</button>)}
      <button className="key wide" onClick={() => handleKey("BACKSPACE")}>⌫</button>
    </div>
    <div className="kb-row">
      <button className={"key wide" + (shifted ? " accent" : "")} onClick={() => handleKey("SHIFT")}>⇧</button>
      {row2.map(k => <button key={k} className="key" onClick={() => handleKey(k)}>{displayKey(k)}</button>)}
    </div>
    <div className="kb-row">
      {row3.map(k => <button key={k} className="key" onClick={() => handleKey(k)}>{displayKey(k)}</button>)}
    </div>
    <div className="kb-row">
      <button className="key" onClick={() => handleKey(",")}>,</button>
      <button className="key" onClick={() => handleKey(".")}>.</button>
      <button className="key extra-wide" onClick={() => handleKey("SPACE")}>space</button>
      <button className="key" onClick={() => handleKey("@")}>@</button>
      <button className="key" onClick={() => handleKey("-")}>-</button>
    </div>
  </div>;
}
